import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor(private http: HttpClient) { }

  getUsuarios(): Observable<any[]>{
    return this.http.get<any[]>(environment.BASE_URL+"/api/getUsuarios/");
  }

  getUsuariosInactivos(): Observable<any[]>{
    return this.http.get<any[]>(environment.BASE_URL+"/api/getUsuariosInactivos/");
  }

  agregarUsuario(data): Observable<any[]>{
    return this.http.post<any[]>(environment.BASE_URL+"/api/agregarUsuario/", data);
  }

  editarUsuario(data): Observable<any[]>{
    return this.http.post<any[]>(environment.BASE_URL+"/api/editarUsuario/", data);
  }

  updateUsuario(data): Observable<any[]>{
    return this.http.post<any[]>(environment.BASE_URL+"/api/updateUsuario/", data);
  }

  desactivarUsuario(data): Observable<any[]>{
    return this.http.post<any[]>(environment.BASE_URL+"/api/desactivarUsuario/", data);
  }

  activarUsuario(data): Observable<any[]>{
    return this.http.post<any[]>(environment.BASE_URL+"/api/activarUsuario/", data);
  }
}
